import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';

const FacilityFloorPlanDtoSchema = z.object({
  id: z.number(),
  bedNumber: z.string(),
  roomNumber: z.string(),
  floorName: z.string(),
  floorId: z.number(),
  isOccupied: z.boolean(),
  primaryOccupantFullName: z.string().nullable(),
  secondOccupantFullName: z.string().nullable(),
  hall: z.string(),
  facilityId: z.number(),
  facilityName: z.string().nullable(),
});

const GetFacilityFloorPlanResponseDtoSchema = PagePaginationResponseDtoSchema(
  FacilityFloorPlanDtoSchema
);

export type GetFacilityFloorPlanRequestDto = PagePaginationRequestDto<
  {
    /** Omit for the portfolio view: every facility the user can access. */
    facilityId?: number;
    /** Portfolio-mode facility filter. Ignored when facilityId is set. */
    facilitiesIds?: number[];
    status?: boolean;
    floor?: number;
    search?: string;
  },
  'bedNumber' | 'roomNumber' | 'floor' | 'status' | 'hall' | 'facility'
>;

export type GetFacilityFloorPlanResponseDto = z.infer<
  typeof GetFacilityFloorPlanResponseDtoSchema
>;
export type FacilityFloorPlanDto = z.infer<typeof FacilityFloorPlanDtoSchema>;

export const getFacilityFloorPlan = (
  params: GetFacilityFloorPlanRequestDto,
  config?: AxiosRequestConfig
) => {
  return api
    .get('/floor-plan', {
      params,
      ...config,
    })
    .then(responseContract(GetFacilityFloorPlanResponseDtoSchema));
};
